import { DropDownCell } from "./Default/DropDownCell";
import { CustomGridCellProps } from "./CustomGridCellProps";
import { GridRowClickProps } from "../GridRowClickProps";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

export function ScopeDropdownCell({
  editable,
  isReadOnly,
  ...props
}: CustomGridCellProps & GridRowClickProps & ReadOnlyProps) {
  return (
    <DropDownCell
      {...props}
      localizedData={scopeLocalizedData}
      editable={editable ?? true}
      isReadOnly={isReadOnly}
    />
  );
}

const scopeLocalizedData = [
  { text: "In Scope", value: true },
  { text: "Out of Scope", value: false },
];
